import {connect} from "react-redux"
import {IncomingHttpHeaders} from "http"
import type State from "../../ducks/state"
import {setIsInTertiaryNav, setTertiaryNavIndex} from "../../ducks/secondary-nav"
import {setActivity} from "../../ducks/accordion-activity"
import {REALM_HEADER} from "../../config/constants"

export const mapStateToProps = (state: State, props) => {
    const department = state.primarynav.activeDepartment
    const key = `${department}-${props.title}`
    const {isImagePlaceholderEnabled} = state.secondarynav
    const {testingVariant = ""} = state?.secondarynav?.catalogues[department] || ""
    const templating = state.template
    const realm = (state.request.headers as IncomingHttpHeaders)[REALM_HEADER] as string
    const {variant, iconsVersionPath} = state.settings

    return {
        isImagePlaceholderEnabled,
        opened: state.accordionActivity[key] || false,
        text: state.text.catalogueList.chevronIconAltText,
        realm,
        testingVariant,
        variant,
        iconsVersionPath,
        templating,
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        setOpened: (title: string | null) => {
            dispatch(setActivity(title))
        },
        setSlideOpened: (isOpened: boolean, catalogueIndex: number) => {
            dispatch(setTertiaryNavIndex(catalogueIndex))
            dispatch(setIsInTertiaryNav(isOpened))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
